import { visibleButton } from "../include/module";
import { anchorLink } from "../include/module";



const breakPointPC = 1279;
const breakPointSP = 767;
let resizeFlag     = false;
let windowWidth    = window.innerWidth;
let windowHeight   = window.innerHeight;
let windowWidthJ   = $(window).width();



// ------------------------------------------------------------------------
// toggleQuestion
// ----- BOTH
// ------------------------------------------------------------------------
const toggleQuestion = () => {
  let targetButtons  = document.querySelectorAll('.idx-Campaign_Question_Button');
  let targetContents = document.querySelectorAll('.idx-Campaign_Question_Content');
  let targetButtonsArray = Array.prototype.slice.call(targetButtons,0);
  targetButtonsArray.forEach((targetButton, index) => {
    targetButton.addEventListener('click', () => {
      if (targetButton.classList.contains('is-Close')) {
        targetButton.classList.remove('is-Close');
        setTimeout(() => { targetContents[index].classList.remove('is-Close-H'); }, 0);
        setTimeout(() => { targetContents[index].classList.remove('is-Close-O'); }, 325);
      } else {
        targetButton.classList.add('is-Close');
        setTimeout(() => { targetContents[index].classList.add('is-Close-O'); }, 0);
        setTimeout(() => { targetContents[index].classList.add('is-Close-H'); }, 325);
      }
    }, false);
  });
};



(() => {
  toggleQuestion();
  visibleButton();
  anchorLink();
})();



// WEBPACK FOOTER //
// script.js